import JSZip from 'jszip';


export const downloadFolderAsZip = async (data, dir) => {
    const jszip = new JSZip();
    const promises = data.map(async (item) => {
        const response = await fetch(item.url);
        const responseBlob = await response.blob();
        jszip.file(item.name, responseBlob);
    })
        .reduce((acc, curr) => acc.then(() => curr), Promise.resolve());
    await promises;
    const blob = await jszip.generateAsync({ type: 'blob' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `download_all_${dir}.zip`;
    link.target = '_blank';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    link.remove();
};

export const downloadSMSAsZip = async (data) => {
    let text = '';
    data.map((item) => {
        text += `From: ${item.from}\nDate: ${item.date}\nMessage: ${item.message} \n----\n`

    });
    const blob = new Blob([text], { type: 'text/plain' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `download_all_sms.txt`;
    link.target = '_blank';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    link.remove();
}

export const downloadContactsAsZip = async (data) => {
    let text = '';
    console.log(data)
    data.map((item) => {
        text += `Name: ${item.givenName}\nPhone number: ${item.phoneNumber} (${item.label}) \n----\n`

    });
    const blob = new Blob([text], { type: 'text/plain' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `download_all_contacts.txt`;
    link.target = '_blank';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    link.remove();
}

// export const downloadFolderAsZip = async () => {
//   const jszip = new JSZip();
//   const storage = getStorage();
//   const folderRef = ref(
//     storage,
//     'images'
//   );
//   const folder = await listAll(folderRef);
//   const promises = folder.items
//     .map(async (item) => {
//       const file = await getMetadata(item);
//       const fileRef = ref(storage, item.fullPath);
//       const fileBlob = await getDownloadURL(fileRef).then((url) => {
//         return fetch(url).then((response) => response.blob());
//       });
//       jszip.file(file.name, fileBlob);
//     })
//     .reduce((acc, curr) => acc.then(() => curr), Promise.resolve());
//   await promises;
//   const blob = await jszip.generateAsync({ type: 'blob' });
//   saveAs(blob, 'download.zip');
// };
